import { makeStyles } from '@material-ui/core';
import { FontFamily } from '@principal-developer-portal/ui';

// eslint-disable-next-line max-lines-per-function
export const useAutofixStyles = makeStyles(theme => ({
  container: {
    marginTop: '16px',
    marginBottom: '16px',
    padding: '0px',
    backgroundColor: 'transparent',
    borderRadius: '8px',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
  },
  sparklesIcon: {
    width: '20px',
    height: '20px',
  },
  heading: {
    fontFamily: FontFamily.Bold,
    fontSize: '16px',
  },
  description: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    marginBottom: '12px',
  },
  contentContainer: {
    marginTop: '12px',
    padding: '16px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
  },
  llmSection: {
    marginBottom: '0px',
  },
  recommendation: {
    padding: '12px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
    marginBottom: '12px',
  },
  recommendationText: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    whiteSpace: 'normal',
  },
  // Container for regenerate button and feedback section (horizontal layout)
  regenerateAndFeedbackContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    marginTop: '8px',
  },
  divider: {
    margin: '16px 0',
  },
  autofixSection: {
    marginTop: '0px',
  },
  autofixTitle: {
    fontFamily: FontFamily.Bold,
    fontSize: '14px',
    marginBottom: '8px',
  },
  // Title for autofix section (h4 style)
  autofixSectionTitle: {
    fontFamily: FontFamily.Bold,
    fontSize: '18px',
    marginBottom: '8px',
    color: theme.palette.text.primary,
  },
  // Subtitle for autofix section (h6 style)
  autofixSectionSubtitle: {
    fontFamily: FontFamily.Regular,
    fontSize: '13px',
    marginBottom: '12px',
    lineHeight: '16px',
  },
  autofixValue: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    // @ts-expect-error custom color
    backgroundColor: `${theme.palette.lightGray}`,
    padding: '12px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.primary.main}`,
    wordBreak: 'break-all',
    marginBottom: '12px',
  },
  autofixDescription: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '8px',
  },
  resourceCountBox: {
    marginBottom: '16px',
    padding: '16px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '12px',
  },
  loadingSpinner: {
    marginRight: '8px',
  },
  loadingText: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
  },
  errorContainer: {
    marginTop: '12px',
  },
  errorMessageSimple: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '8px 0',
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: theme.palette.background.paper,
    padding: '12px',
    borderRadius: '4px',
  },
  errorIcon: {
    color: theme.palette.error?.main,
    fontSize: '20px',
    flexShrink: 0,
  },
  errorText: {
    color: theme.palette.text.primary,
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
  },
  inProgressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '8px 0',
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: theme.palette.background.paper,
    padding: '12px',
    borderRadius: '4px',
  },
  inProgressMessage: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  retryMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '8px 0',
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
  },
  successMessage: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.success.main,
    backgroundColor: theme.palette.background.paper,
    padding: '12px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.status.ok}`,
    marginBottom: '12px',
  },
  clickableAction: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: theme.palette.primary.main,
    fontFamily: FontFamily.Bold,
    fontSize: '14px',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: '4px 0',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '&:hover': {
      textDecoration: 'underline',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '&:disabled': {
      color: theme.palette.text.disabled,
      cursor: 'not-allowed',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  actionIcon: {
    fontSize: '16px',
    color: 'inherit',
  },
  attemptCount: {
    color: theme.palette.text.primary,
    fontFamily: FontFamily.Regular,
  },
}));
